import { supabase } from "../../Services/supabaseClient";

export async function uploadTradeAttachment({
  company_id,
  entity_type,
  entity_id,
  file,
}) {
  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData?.session?.access_token;
  if (!token) throw new Error("Not authenticated.");

  const base64 = await fileToBase64(file);
  const fnUrl = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/trade-attachment-upload`;

  const res = await fetch(fnUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      company_id,
      entity_type,
      entity_id,
      file_name: file.name,
      content_type: file.type || "application/octet-stream",
      base64,
    }),
  });

  const raw = await res.text();
  let json = {};
  try {
    json = raw ? JSON.parse(raw) : {};
  } catch {
    json = { error: raw || "Unknown error" };
  }
  if (!res.ok) throw new Error(json?.error || "Upload failed");
  return json.attachment;
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const result = String(r.result || "");
      // strip data:...;base64,
      const base64 = result.includes(",") ? result.split(",")[1] : result;
      resolve(base64);
    };
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
